<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
        <div class="container-fluid mt--9">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row">
                                <div class="col-sm-2">
                                    <h3 class="mb-0 mt-2">Ordenes de Compra</h3>
                                </div>
                                <div class="col-sm-3 mt-1">
                                    <!-- Multiselect to select the type of search in the PO -->
                                    Buscar por:
                                    <multiselect
                                        v-model="searchType"
                                        :options="searchOptions"
                                        placeholder="Selecciona un tipo de busqueda"
                                    ></multiselect>
                                </div>
                                <div class="col-sm-4 mt-4">
                                    <base-input v-model="searchInput" placeholder="Escribe tu busqueda" style="transform: scale(1.0);transform-origin:left;"></base-input>
                                </div>
                                <div class="col-sm-2 mt-4">
                                    <base-button class="ml-3 mr-3 mb-3 active" @click="openPO(searchInput)" tag="a" type="default" size="md" href="#" role="button" aria-pressed="true">Buscar</base-button>
                                </div>
                            </div>
                            <hr>
                            <div class="row ml-4">
                                <base-button type="danger" @click="openCalendar()">
                                    Ver Calendario ADUANA
                                </base-button>
                            </div>
                        </div>
                        <div class="col-sm-12 mt-4 mb-4" style="" v-if="isLoading">
                            <center>
                                <img
                                src="img/loader.gif"
                                class="img-responsive"
                                style="width: 40px"
                                /><br />Cargando Ordenes de Compra...
                            </center>
                        </div>
                        <div class="table-responsive" style="padding-top:10px" v-if="!isLoading">
                            <base-table thead-classes="thead-light" :data="filterData">
                                <template slot="columns">
                                    <th><center>DocNum</center></th>
                                    <th><center>CardCode</center></th>
                                    <th><center>CardName</center></th>
                                    <th><center>DocDate</center></th>
                                    <th><center>DocTotal</center></th>
                                    <th></th>
                                </template> 
                                <template slot-scope="{ row }">
                                    <th scope="row">
                                        <center>
                                        <a style="font-size: 12px">{{ row.DocNum }} </a>
                                        </center>
                                    </th>
                                    <th scope="row">
                                        <center>
                                        <a style="font-size: 12px">{{ row.CardCode }} </a>
                                        </center>
                                    </th>
                                    <th scope="row">
                                        <center>
                                        <a style="font-size: 12px">{{ row.CardName }} </a>
                                        </center>
                                    </th>
                                    <th scope="row">
                                        <center>
                                        <a style="font-size: 12px">{{ row.DocDate }} </a>
                                        </center>
                                    </th>
                                    <th scope="row">
                                        <center>
                                        <a style="font-size: 12px">${{ row.DocTotal }} </a>
                                        </center>
                                    </th>
                                </template>
                            </base-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>

<script>
import { getAuth } from "firebase/auth";
import Multiselect from "vue-multiselect";
import axios from 'axios'

export default {
    components: {
        Multiselect
    },
    created(){
        axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    },
    beforeMount() {
        /**
         * * Function to Set Permissions
         */
        const user = getAuth().currentUser;
        if( user.email != 'brendaterrazas@canplast.com.mx' && 
            user.email != 'edricbaeza@canplast.com.mx' && 
            user.email != 'elesbantrevizo@canplast.com.mx' && 
            user.email != 'aaronroman@canplast.com.mx' && 
            user.email != 'daliahernandez@canplast.com.mx' && 
            user.email != 'dianaquinonez@canplast.com.mx' && 
            user.email != 'yeseniaarellanes@canplast.com.mx' && 
            user.email != 'alfredoreyes@canplast.com.mx' && 
            user.email != 'idalyvillalobos@canplast.com.mx' && 
            user.email != 'estefaniasalas@canplast.com.mx' && 
            user.email != 'concepcionnuno@canplast.com.mx' && 
            user.email != 'leslysifuentes@canplast.com.mx'
        ){
            this.$swal.fire({
                title: "Error",
                text: "No tienes permisos para acceder a esta página",
                icon: "error",
                showConfirmButton: true,
            })
            this.$router.push({ path: '/' })
        }
    },
    data() {
        return {
            sidebarBackground: "vue", //vue|blue|orange|green|red|primary
            user: null,
            tableData: [],
            filterData: [],
            searchInput: null,
            showPO: false,
            loaderPO: false,
            selectedPO: null,
            isLoading: true,
            searchOptions:["Folio","Código de proveedor", "Shipment ID"],
            searchType: null
        };
    },
    mounted() {
        setTimeout(() => {
            this.getEntries();
        }, 1000);
    },
    methods: {
        /* 
        * * Method to get the result of the search
        * * This redirects to the selected type of search
        */
        openPO(DocNum){
            if(this.searchType === "Folio"){
                this.$router.push({ path: 'purchaseOrder', query: { DocNum: DocNum }})
            }
            else if(this.searchType === "Código de proveedor"){
                this.$router.push({ path: 'purchaseOrderFilter', query: { CardCode: DocNum }})
            }
            else if(this.searchType === "Shipment ID"){
                this.$router.push({ path: 'purchaseOrderFilter', query: { ShipmentID: DocNum }})
            }
        },
        /**
         * * Method to open the view of the calendar ADUANA
         */
        openCalendar(){
            this.$router.push({ path: 'calendario/aduana'})
        },
        /* 
         * * Method to save all changes made in the modal
         */
        guardarCambios(){
        },
        /*
        * * HTTP Request via axios to return  open purchase orders
        */
        getEntries() {
            axios.get(`/api/purchase_orders`)
            .then((result) => {
                this.filterData = result.data.value;
                this.$forceUpdate();
                this.isLoading = false;
            })
            .catch(() => {
                this.$swal.fire({
                    title: "Error",
                    text: "No se pudo obtener los datos",
                    icon: "error",
                    showConfirmButton: true,
                })
            });
        },
    },
    computed:{
        filteredAndSorted(){
            const res = this.filterData.filter(po => {
                return po.PurchaseOrders.includes(this.searchInput)
            })
            return res   
        }
    }
};
</script>